// Mixins
import { userMixins } from "@/app/mixins/modules/user-mixins.js"

export default {
	name: "ProductItemCard",
	mixins: [userMixins],
	props: {
		list: {
			type: Object,
			required: true,
		},
		viewProduct: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			ageList: {
				A: "Adult",
				P: "Puppy",
			},
			isReadMore: false,
		}
	},
	methods: {
		checkIfMultipleBrands(bundleProducts) {
			// Remove Null and Duplicate Brands in a single Product List.
			const brands = [...new Set(bundleProducts.map((item) => item.brand.name))]

			return {
				name: brands.length > 1 ? "MULTIPLE BRANDS" : brands[0],
				brands,
				isMultiple: brands.length > 1,
			}
		},
		getImage(list) {
			if (list.isCustomBundle || this.viewProduct) {
				let img = require("@/assets/images/product/dog-default-picture-color.png")
				if (list.productImg) {
					img = list.productImg
				}
				if (list.imageUrl) {
					img = list.imageUrl
				}
				return img
			} else {
				return list.products[0].imageUrl
					? list.products[0].imageUrl
					: require("@/assets/images/product/dog-default-picture-color.png")
			}
		},

		replaceWithImagePlaceholder(event) {
			event.target.src = require("@/assets/images/product/dog-default-picture-color.png")
		},

		showItemModal(list) {
			this.$emit("showItemModal", list)
		},

		showImageModal(list) {
			if (!this.viewProduct) {
				return
			}

			this.$swal({
				imageHeight: 250,
				imageUrl: this.getImage(list),
				imageAlt: "Image",
				title: list.name,
				text: list.description ? list.description : "",
			})
		},

		readMoreAndModal(list) {
			this.showImageModal(list)
		},

		stocksAvailable(stockQty) {
			return stockQty <= 0 || stockQty === null ? "Out of Stock" : `Available Qty: ${stockQty}`
		},

		displayQtyOnCartAndCheckout(list) {
			return (
				this.$route.path.includes("/products/cart") ||
				(this.$route.path.includes("/products/checkout") && list.productInventory)
			)
		},

		displayQtyOnProductListing(list) {
			return (
				!this.$route.path.includes("/purchases/product-transactions") &&
				!this.$route.path.includes("/products/cart") &&
				!this.$route.path.includes("/products/checkout") &&
				!list.subscriptionBundle &&
				!list.isCustomBundle
			)
		},
	},
}
